import { render, staticRenderFns } from "./CelebrationModalTest.vue?vue&type=template&id=4ee857f3&scoped=true&"
import script from "./CelebrationModalTest.vue?vue&type=script&lang=ts&"
export * from "./CelebrationModalTest.vue?vue&type=script&lang=ts&"
import style0 from "./CelebrationModalTest.vue?vue&type=style&index=0&id=4ee857f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee857f3",
  null
  
)

export default component.exports